exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".preview-link-dialog .mw-mini-modal__cancel-button{display:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/newsletter-distributions/preview-link-dialog/preview-link-dialog.component.css
 ** module id = 50
 ** module chunks = 0 1
 **/